
import Component from "vue-class-component";
import Vue from "vue";
import { OrderTypeToDeliveryTypeMappingModule, SystemModule } from "@/store/modules";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { IOrderTypeToDeliveryTypeMapping } from "@/store/types";

const systemModuleState = getModule(SystemModule);
const orderTypeToDeliveryTypeMappingModuleState = getModule(OrderTypeToDeliveryTypeMappingModule);

import { formatDateWithTime } from "@/utils";
import notifications from "../../lib/notifications";
@Component({
  components: {
    Select
  }
})
export default class OrderTypeMaintenance extends Vue {
  orderTypeToDeliveryTypeMappings: IOrderTypeToDeliveryTypeMapping[] = null;
  loading: boolean = false;

  modalVisible: boolean = false;
  modalIsNew: boolean = false;
  modalLoading: boolean = false;
  modalSaving: boolean = false;
  modalOrderTypeToDeliveryTypeMapping: IOrderTypeToDeliveryTypeMapping;

  get options() {
    return [{label: "Delivery", value: "DEL"},{label: "Pickup/Return", value: "RET"}, {label: "Will Call", value: "WILL"}];
  }

  formatOrderType(orderType: string) {
    if(orderType === "DEL") return "Delivery";
    if(orderType === "RET") return "Pickup/Return";
    if(orderType === "WILL") return "Will Call";
    return orderType;
  }

  formatDeliveryType(deliveryType: string){
    return deliveryType;
    //return systemModuleState.deliveryTypes.find((x) => x.id === deliveryType).name;
  }

  async created() {
    await this.loadOrderTypeToDeliveryTypeMappings();
  }

  async loadOrderTypeToDeliveryTypeMappings() {
    this.loading = true;
    this.orderTypeToDeliveryTypeMappings = await orderTypeToDeliveryTypeMappingModuleState.getOrderTypeToDeliveryTypeMapping();
    this.orderTypeToDeliveryTypeMappings.forEach(mapping => mapping["Existing"] = (mapping.orderType !== ""));
    this.loading = false;
  }

  async saveOrderTypeToDeliveryTypeMapping() {
    try {
      this.modalSaving = true;
      if (this.modalOrderTypeToDeliveryTypeMapping["Existing"] === true) {
        await orderTypeToDeliveryTypeMappingModuleState.updateOrderTypeToDeliveryTypeMapping(this.modalOrderTypeToDeliveryTypeMapping);
      } else {
        await orderTypeToDeliveryTypeMappingModuleState.addOrderTypeToDeliveryTypeMapping(this.modalOrderTypeToDeliveryTypeMapping);
      }

      notifications.success("Mapping Saved", "Successfully saved mapping.");
    } catch (ex) {
      notifications.error("Mapping", "Failed to save mapping.", ex);
    } finally {
      this.closeModal()
      this.modalSaving = false;

      await this.loadOrderTypeToDeliveryTypeMappings();
    }
  }
  
  async editOrderTypeToDeliveryTypeMapping(orderTypeToDeliveryTypeMapping: IOrderTypeToDeliveryTypeMapping = null) {
    this.modalSaving = false;
    this.modalLoading = true;
    this.modalOrderTypeToDeliveryTypeMapping = { ...orderTypeToDeliveryTypeMapping };
    this.modalVisible = true;
    this.modalLoading = false;
  }

  closeModal() {
    this.modalVisible = false;
  }
}
